module.exports = __webpack_public_path__ + "e3c004470d2af3095108f314eb23f3bb.pdf";